// Finance build (Workstream C — Amortization) — query-key factory for the loan
// amortization read. queryKey arrays live ONLY in *Keys files (stale-after-save
// convention).

export const amortizationKeys = {
  loan: (loanId: string) =>
    ["portfolio-admin", "loan", loanId, "amortization"] as const,
};
